import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageContainer from "../../components/page-container";
import Button from "../../components/button";
// import googleIcon from "../../assets/google.svg";
import appleIcon from "../../assets/apple.svg";
// import outlookIcon from "../../assets/outlook.svg";
import googleIcon from "../../assets/blackgcalicon.svg";
import outlookIcon from "../../assets/blackoutlookicon.svg";
import { useSections } from "../../hooks/use-sections";
import { useClerkAuth } from "../../hooks/use-clerk-auth";
import { useCalendarActions } from "../../hooks/use-calendar-actions";
import s from "./styles.module.scss";
import PageHeader from "../../components/page-header";
import { ReactComponent as InfoIcon } from "../../assets/info.svg"; 


const SelectCalendar = () => {
  console.log("[DEBUG] SelectCalendar component mounted");

  const navigate = useNavigate();
  const [selectedCalendar, setSelectedCalendar] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [coursesWithDetails, setCoursesWithDetails] = useState([]);
  const [isAdding, setIsAdding] = useState(false);

  const { selectedSections } = useSections();
  const { user } = useClerkAuth();
  const { selectCalendar } = useCalendarActions();
  const isAuthenticated = !!user;

  console.log("[DEBUG] selectedSections:", selectedSections);
  console.log("[DEBUG] All sections data", localStorage.getItem("allSectionsData"));
  console.log("[DEBUG] isAuthenticated:", isAuthenticated);
  console.log("[DEBUG] user:", user);

  const calendars = [
    { id: "outlook", name: "Outlook", icon: outlookIcon },
    { id: "apple", name: "Apple", icon: appleIcon },
    { id: "google", name: "Google", icon: googleIcon },
  ];

  // useEffect(() => {
  //   const coursesData = localStorage.getItem("courses");
  //   if (coursesData && selectedSections.length > 0) {
  //     try {
  //       const courses = JSON.parse(coursesData);
  //       const coursesWithInfo = selectedSections.map((section) => {
  //         // Find matching course by ID or course code
  //         const matchingCourse = courses.find(
  //           (course) => 
  //             course.id === section.courseId || 
  //             course.course_code === section.courseCode
  //         );
          
  //         if (matchingCourse) {
  //           const selectedSection = matchingCourse.selected_section;
  //           return {
  //             id: matchingCourse.id,
  //             courseName: matchingCourse.course_name,
  //             color: matchingCourse.color || "#039be5",
  //             days: selectedSection?.days_of_week || "",
  //             location: selectedSection?.location || "",
  //             timing: selectedSection?.timing || "",
  //           };
  //         }
  //         return null;
  //       }).filter(Boolean);
        
  //       setCoursesWithDetails(coursesWithInfo);
  //     } catch (error) {
  //       console.error("Error parsing courses data:", error);
  //     }
  //   }
  // }, [selectedSections]);

  useEffect(() => {
  const allSectionsData = localStorage.getItem("allSectionsData");
  
  if (allSectionsData) {
    try {
      const sectionsData = JSON.parse(allSectionsData);
      console.log("[DEBUG] allSectionsData:", sectionsData);
      
      // Get all courses from allSectionsData that have been processed
      const coursesWithInfo = Object.entries(sectionsData).map(([filePath, courseData]) => {
        // Some courses might have a sections array, others might have the section data directly
        const section = courseData.sections && courseData.sections.length > 0 
          ? courseData.sections[0] 
          : courseData;
        
        return {
          id: filePath,
          courseName: courseData.course_name || section.name || courseData.name,
          color: courseData.color || "#039be5",
          days: section.days_of_week || courseData.days_of_week || "",
          location: section.location || courseData.location || "Asynchronous",
          timing: section.timing || courseData.timing || "",
        };
      });
      
      console.log("[DEBUG] coursesWithInfo:", coursesWithInfo);
      setCoursesWithDetails(coursesWithInfo);
    } catch (error) {
      console.error("Error parsing sections data:", error);
    }
  }
}, []);

  // Add useEffect to detect OAuth completion
  useEffect(() => {
    console.log("[DEBUG] SelectCalendar useEffect running");
    const authCompleted = localStorage.getItem("googleAuthInProgress");
    console.log("[DEBUG] googleAuthInProgress:", authCompleted);

    if (authCompleted) {
      console.log(
        "[DEBUG] OAuth completed, should auto-trigger handleAddEvents"
      );
    }
  }, []);

  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe && currentSlide < calendars.length - 1) {
      setCurrentSlide(currentSlide + 1);
    }
    if (isRightSwipe && currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  const handleCalendarSelect = (calendarId, e) => {
    if (selectedCalendar === calendarId) {
      setSelectedCalendar(null);
    } else {
      setSelectedCalendar(calendarId);
    }

    // remove focus from button after click
    if (e && e.currentTarget) {
      e.currentTarget.blur();
    }
  };

  const handleDotClick = (index) => {
    setCurrentSlide(index);
  };

  const handleAddEvents = async () => {
    // If no calendar selected, default to "ocean" (store in Ocean only)
    const calendarToUse = selectedCalendar || "ocean";

    if (
      (calendarToUse === "google" || calendarToUse === "outlook") &&
      !isAuthenticated
    ) {
      alert("You must log in before adding events.");
      return;
    }

    setIsAdding(true);
    try {
      // Simply call selectCalendar for all types - it handles credential checking
      await selectCalendar(calendarToUse);
    } finally {
      setIsAdding(false);
    }
  };

  return (
    <PageContainer>
      <PageHeader
        title='Sync to Calendar'
        description='Click the "Add events to calendar" button below to extract and sync events to your Ocean calendar'
      />

      {coursesWithDetails.length > 0 && (
        <div className={s.courseList}>
          {coursesWithDetails.map((course) => (
            <div key={course.id} className={s.courseItem}>
              <svg
                className={s.courseDiamond}
                width="16"
                height="16"
                viewBox="0 0 16 16"
              >
                <rect
                  width="11"
                  height="11"
                  x="2.5"
                  y="2.5"
                  fill={course.color}
                  transform="rotate(45 8 8)"
                />
              </svg>
              <span className={s.courseText}>
                {course.courseName} - {course.days} - {course.location}
              </span>
            </div>
          ))}
        </div>
      )}

      <p className={s.optionalSyncText}>Optionally sync to your 3rd-party calendar of choice</p>

      <div className={s.infoMessage}>
              <InfoIcon className={s.infoIcon} />
              <span>Some universities restrict calendar access. If blocked, use your personal email to sync</span>
            </div>

      <div className={s.calendarSection}>
        <div className={s.calendarGrid}>
          {calendars.map((calendar) => {
            const isSelected = selectedCalendar === calendar.id;
            return (
              <button
                key={calendar.id}
                className={`${s.calendarCard} ${
                  isSelected ? s.calendarCardSelected : ""
                }`}
                onClick={(e) => handleCalendarSelect(calendar.id, e)}
                type="button"
              >
                <img
                  src={calendar.icon}
                  alt={`${calendar.name} Calendar`}
                  className={s.calendarIcon}
                />
              </button>
            );
          })}
        </div>

        <div className={s.calendarCarousel}>
          <div
            className={s.carouselContainer}
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
          >
            <div
              className={s.carouselTrack}
              style={{ transform: `translateX(-${currentSlide * 171}px)` }}
            >
              {calendars.map((calendar) => {
                const isSelected = selectedCalendar === calendar.id;
                return (
                  <div key={calendar.id} className={s.carouselSlide}>
                    <button
                      className={`${s.calendarCard} ${
                        isSelected ? s.calendarCardSelected : ""
                      }`}
                      onClick={(e) => handleCalendarSelect(calendar.id, e)}
                      type="button"
                    >
                      <img
                        src={calendar.icon}
                        alt={`${calendar.name} Calendar`}
                        className={s.calendarIcon}
                      />
                    </button>
                  </div>
                );
              })}
            </div>
          </div>

          <div className={s.dotsContainer}>
            {calendars.map((_, index) => (
              <button
                key={index}
                className={`${s.dot} ${
                  index === currentSlide ? s.dotActive : ""
                }`}
                onClick={() => handleDotClick(index)}
                type="button"
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>

      <Button
        variant="primary"
        onClick={handleAddEvents}
        className={s.addEventsButton}
        loading={isAdding}
        disabled={isAdding}
      >
        Add events to calendar
      </Button>
    </PageContainer>
  );
};

export default SelectCalendar;